export default __webpack_public_path__ + "static/media/Boots of the Ragereaver.854be23b.jpg";